import * as React from "react";
import styled, { css } from "../../../styled/index";
import {shadeAlternate} from "../../../styled/helpers";
import {CS} from "../../../styles/index";
import autobind from "autobind-decorator";

const ClickOutComponent = require("react-onclickout");

export const Wrapper = styled("div")`
  position: relative;
`;

export const ChildContent = styled("div")`
  cursor: pointer;
`;

export const Dropdown = styled("div")<{ active: boolean }>`
  position: absolute;
  display: ${({active}) => active ? "block" : "none"};
  top: calc(100% + 4px);
  height: auto;
  min-width: 100px;
  width: 100%;
  border-radius: 5px;
  background: ${({theme}) => theme.box.background};
  color: ${({theme}) => theme.box.text};
  ${CS.shadow.heavy.one};
  z-index: 2;
`;

export const Content = styled("div")`
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
`;

export const Item = styled("div")`
  cursor: pointer;
  padding: 10px 10px;
  border-radius: 5px;
  &:hover {
    background: ${({theme}) => shadeAlternate(0.06, theme.box.background)};
  }
`;

interface Props {
  options: GenericOption[];
  children: React.ReactNode;
  onSelect: (selected: GenericOption) => void;
}

interface State {
  active: boolean;
}

export class DropDownList extends React.Component<Props, State> {

  clickOutActive: boolean = false;

  constructor(props: Props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.clickOutActive = this.state.active;
    }, 100);
  }

  setActive = (active: boolean) => {
    this.setState({ active });
  }

  onClickOut = () => {
    if (this.state.active && this.clickOutActive) {
      this.setActive(false);
    }
  }

  onSelect = (selected: GenericOption) => {
    this.setActive(false);
    this.props.onSelect(selected);
  }

  render() {
    if (!this.state) return;
    const { active } = this.state;
    const { options, children } = this.props;
    return (
      <Wrapper>
        <ChildContent onClick={() => this.setActive(!active)}>
          {children}
        </ChildContent>
        <ClickOutComponent
          onClickOut={this.onClickOut}>
          <Dropdown active={active}>
            <Content>
              {options.map((o, i) => (
                <Item key={i} onClick={() => this.onSelect(o)}>{o.label}</Item>
              ))}
            </Content>
          </Dropdown>
        </ClickOutComponent>
      </Wrapper>
    );
  }

}
